<script lang="ts">
  import { defineComponent } from 'vue';
  import Mixins from '@/helpers/mixins';
  import { StatusPopupTypes } from '@/helpers/enums';
  import StatusPopupWrapper from '@/components/ui/popups/StatusPopupWrapper.vue';

  export default defineComponent({
    components: { StatusPopupWrapper },
    mixins: [Mixins],
    props: {
      popupStatus: { type: String as () => StatusPopupTypes, required: true },
      showPopup: { type: Boolean, default: true },
      confirmationButtonText: { type: String, default: null },
      cancelButtonText: { type: String, default: null },
      title: { type: String, default: null },
      subtitle: { type: String, default: null },
      content: { type: String, default: null },
    },
    emits: {
      confirm: () => true,
      cancel: () => true,
    },
  });
</script>

<template>
  <StatusPopupWrapper
    :cancel-button-text="cancelButtonText"
    :confirmation-button-text="confirmationButtonText"
    :popup-status="popupStatus"
    :show-popup="showPopup"
    @cancel="$emit('cancel')"
    @confirm="$emit('confirm')"
  >
    <p v-if="title" class="fw-medium">{{ title }}</p>
    <h2 v-if="subtitle" class="fw-semibold mt-8">{{ subtitle }}</h2>
    <p v-if="content" class="mt-18 paragraph-input text-blue mw-100 text-break">
      {{ content }}
    </p>
  </StatusPopupWrapper>
</template>
